export type ProjectCompletionColumnKey =
  | "auftrag"
  | "kunde"
  | "status"
  | "completed_by"
  | "completed_at"
  | "delivery_notes"
  | "invoices"
  | "actions";

export const PROJECT_COMPLETION_COLUMNS: ProjectCompletionColumnKey[] = [
  "auftrag",
  "kunde",
  "status",
  "completed_by",
  "completed_at",
  "delivery_notes",
  "invoices",
  "actions",
];

export const PROJECT_COMPLETION_COL_MIN_WIDTH = 72;
export const PROJECT_COMPLETION_COL_MAX_WIDTH = 720;

const DEFAULT_WIDTHS: Partial<Record<ProjectCompletionColumnKey, number>> = {
  auftrag: 220,
  kunde: 160,
  status: 148,
  completed_by: 140,
  completed_at: 160,
  delivery_notes: 140,
  invoices: 140,
};

export function getProjectCompletionColumnDefaultWidth(key: string): number {
  return DEFAULT_WIDTHS[key as ProjectCompletionColumnKey] ?? 120;
}

export function clampProjectCompletionColumnWidth(width: number): number {
  return Math.min(
    PROJECT_COMPLETION_COL_MAX_WIDTH,
    Math.max(PROJECT_COMPLETION_COL_MIN_WIDTH, Math.round(width)),
  );
}

export function getProjectCompletionColumnLabel(key: ProjectCompletionColumnKey): string {
  switch (key) {
    case "auftrag":
      return "Auftrag";
    case "kunde":
      return "Kunde";
    case "status":
      return "Status";
    case "completed_by":
      return "Fertiggestellt von";
    case "completed_at":
      return "Fertiggestellt am";
    case "delivery_notes":
      return "Lieferscheine";
    case "invoices":
      return "Rechnungen";
    case "actions":
      return "Aktion";
    default:
      return key;
  }
}

export function isProjectCompletionActionColumn(key: string): boolean {
  return key === "actions";
}
